export const TR = {
  preparing_zip: "Zip hazırlanıyor…",
  compressing: "Sıkıştırılıyor…",
  info_icon: "Tamamlandı olarak işaretlendiğinde, ek üyeler katılamaz veya eklenemez ve tüm sohbet grupları devre dışı bırakılır. Lütfen proje ile birlikte tüm sohbet grupları ve verilerin devre dışı bir durumda erişilebilir kalacağını unutmayın.",
  mark_is_done: "Projeyi tamamlandı olarak işaretlemek istediğinizden emin misiniz? İşaretlendiğinde, ek üyeler katılamaz veya eklenemez ve tüm sohbet grupları devre dışı bırakılır. Lütfen proje ile birlikte tüm sohbet grupları ve verilerin devre dışı bir durumda erişilebilir kalacağını unutmayın.",
  mark_not_done: "Projeyi yeniden açmak istediğinizden emin misiniz? Açık olarak işaretlendiğinde, ek üyeler katılabilir veya eklenebilir ve tüm sohbet grupları yeniden etkinleştirilir.",
  mark_as_completed: "Projeyi tamamlandı olarak işaretle",
  room_completed: "Proje tamamlandı",
  room_members: "Proje üyeleri",
  deactivated_rooms: "Devre dışı bırakılan projeler",
  deactivated_chats: "Devre dışı bırakılan sohbetler",
  completed_rooms: "Tamamlanan projeler",
  request_to_join_a_room: 'Projeye katılma isteği',
  wants_to_rejoin_room: 'Username Roomname projesine yeniden katılmak istiyor.',
  invited_you_to_join_room: 'Username sizi Roomname projesine katılmaya davet etti.',
  restart: "Yeniden başlat",
  update_text: "Yeni bir güncelleme mevcut. Güncellemeyi yüklemek için yeniden başlat'a tıklayın.",
  update_availble: "Güncelleme mevcut",
  Loading: "Yükleniyor...",
  logout: "Çıkış yap",
  back: 'Geri',
  company_list: "Şirket listesi",
  followers: "Takipçiler",
  followings: "Takip edilenler",
  article: "Makale",
  companies: "Şirketler",
  one_to_one_chat: " Bire bir sohbet",
  profile: "Profil",
  company: "Şirket",
  company_selection: "Şirket seçimi",
  home: "Ana sayfa",
  contact: "İletişim ",
  add_company: "Şirket ekle ",
  add_project: "Proje ekle ",
  capacities: "Kapasiteler ",
  work_area: "Çalışma alanı",
  company_services: "Şirket hizmetleri",
  website: "Web sitesi",
  search_contacts: "İletişim ara",
  add_or_join_a_company: "Şirket ekle veya katıl",
  follow: "Takip et",
  following: "Takip ediliyor",
  like: "Beğen",
  company_contacts: "Şirket iletişimi",
  leave_the_company: "Şirketten ayrıl",
  news: "Haberler",
  earlier: "Önceki",
  action: "Eylem",
  another_action: "Başka bir eylem",
  something_else: "Başka bir şey",
  search: "Ara",
  search_rooms: "Proje ara",
  search_articles: "Makale ara",
  contacts: "İletişimler",
  suggestions: "Öneriler",
  project_list: "Proje listesi",
  search_results: "Arama sonuçları",
  add_or_join_project: "Proje ekle veya katıl",
  details: "Detaylar",
  your_position_within_company:
    "Lütfen şirket içindeki pozisyonunuzu seçin.",
  close_modal: "Kapat",
  map: "Harita",
  or: "Veya",
  name: "Ad*",
  street: "Sokak*",
  house_number: "Ev numarası",
  postal_code: "Posta kodu",
  city: "Şehir*",
  opened_by: "Açan:",
  project_No: "Proje no: ",
  building_type: "Bina tipi*",
  building_types: "Bina tipi",
  add_join: "Ekle/Katıl",
  mandatory_fiels: "*zorunlu alanlar",
  invalid_fiels: "Bu alan zorunludur",
  add_or_join_company: "Şirket ekle veya katıl",
  name_of_the_company: "Şirket adı",
  edit_company_details: "Şirket detaylarını düzenle",
  branch_of_the_building_industry: "İnşaat sektörü dalı",
  corporate_form: "Şirket türü",
  position_within_company: "Şirket içindeki pozisyon",
  request_confirmation: "Bekleyen proje istekleri",
  company_e_mail: "Şirket e-postası",
  type_of_filter: "Filtrelemek için yazın...",
  setting: "Ayar",
  dashboard: "Kontrol paneli",
  settings: "Ayarlar",
  views: "Görüntülemeler",
  times_seen: "kez görüntülendi",
  see_more: "...daha fazla",
  see_less: "...daha az",
  in_search: "aramada",
  reset_password: "Şifreyi sıfırla",
  submit: "Gönder",
  password: "Şifre",
  email: "E-posta",
  confirm_password: "Şifreyi onayla",
  reset_email: "E-postayı sıfırla",
  update: "Güncelle",
  new_email: "Yeni e-posta",
  kjuup_message: "Kjuup Mesajı",
  delete_profile: "Profili sil?",
  my_position: "Pozisyonum:",
  add: "ekle",
  owner_company_admin: "Şirket yöneticisi :",
  owner_company_admin_new: "Şirket yöneticisi",
  mutual_contact: "ortak iletişim",
  mutual_contacts: "ortak iletişimler",
  co_owner: "Ortak sahip",
  managing_director: "Genel müdür",
  associate: "Ortak",
  secretary: "Sekreter",
  employee: "Çalışan",
  project_manage: "Proje yöneticisi",
  auto_chat_translation: "Otomatik sohbet çevirisi",
  translate_room_group_names: "Sohbet grubu adlarını çevir",
  translate_room_group_names_info: "Etkinleştirildiğinde sohbet grubu adları otomatik olarak arayüz dilinize çevrilir.",
  default_view_email: "Varsayılan görünüm: E-posta",
  default_view_email_info: "Etkinleştirildiğinde, uygulamayı açtığınızda Mesajlar yerine varsayılan olarak E-Posta sekmesi açılır.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Dil",
  english: "İngilizce",
  german: "Almanca",
  french: "Fransızca",
  italian: "İtalyanca",
  change_language: "Dili değiştir",
  my_companies: "Şirketlerim",
  employees: "Çalışanlar",
  invite_with_a: "Kjuup'a davet et",
  add_member: "Üye ekle",
  add_user: "Kullanıcı ekle",
  send_location: "Konum gönder",
  assign_admin_rights: "Yönetici hakkını ayarla",
  deactivate_company: "Şirketi devre dışı bırak",
  remove_employees: "Çalışanları kaldır",
  remove_members: "Üyeleri kaldır",
  no_user_found: "Kullanıcı bulunamadı!",
  approve: "Onayla!",
  deselect_all: "Tümünü seçimi kaldır",
  select_all: "Tümünü seç",
  translation_on_building_projects: "Projeler içinde çeviri",
  reported_capacities: "Bildirilen hizmetler",
  up_to_50m_exact: "50m'ye kadar tam",
  company_details_service: "Şirket hizmetleri",
  company_contact: "Şirket iletişimi",
  invite_with_link: "Kjuup'a davet et",
  share_link: "Bağlantıyı paylaş",
  share_company_link: "Bağlantıyı paylaş",
  qr_code: "QR kod",
  copy_link: "Bağlantıyı kopyala",
  cancel_link: "Bağlantıyı iptal et",
  who_has_confirmed_services: "Hizmetlerinizi kim onayladı?",
  projectss: "Projeler",
  add_services: "Hizmet ekle",
  services: "Hizmetler",
  save_text: "Kaydet",
  share_on: "Paylaş:",
  articlen: "Makale",
  invite_user_to_confirm_service:
    "Kullanıcıları şirkete hizmet onaylamaya davet edin.",
  link_copied: "Bağlantı kopyalandı!",
  email_copied: "E-posta kopyalandı!",
  personal_article: "Kişisel makale",
  company_article: "Şirket makalesi",
  characters_remaining: "Kalan karakter",
  optional_information: "İsteğe bağlı bilgi",
  project: "Proje",
  projects: "Projeler...",
  abort: "İptal et",
  preview: "Önizleme",
  post: "Yayınla",
  of: "veya",
  remove: "Kaldır",
  free_capacity: "İş portalı",
  current_status_overview: "Mevcut durum özeti",
  report_capacities: "Hizmet bildir",
  report_text: "Bildir",
  search_capacities: "Yüklenici bul",
  add_project_user: "Proje kullanıcısı ekle",
  media: "Medya",
  links: "Bağlantilar",
  docs: "Belgeler",
  featured_products: "Öne çıkan ürünler...",
  title: "Başlık",
  text: "Metin",
  feed_details: "Akış detayları",
  add_employee: "Çalışan ekle",
  latest: "En son",
  my_projects: "Projelerim",
  cancel: "İptal",
  continue: "Devam et",
  role_in_the_building_industry: "İnşaat sektöründeki rol",
  als: "olarak",
  join: "katıl",
  find: "Bul",
  request_to_join_a_company: "Şirkete katılma isteği",
  wants_to_join_the_company: "şirkete katılmak istiyor",
  filter_by: "Filtrele",
  ok: "Tamam",
  close: "Kapat",
  weekly_statistics: "Haftalık istatistikler",
  is_following_you: "sizi takip ediyor.",
  as: "olarak",
  has_joined_the: "şirkete katıldı",
  has_looked_at_your_profile: "profilinize baktı.",
  time: "Saat",
  in_searches_in_past_week: "geçen hafta aramalarda.",
  has_liked_your_article: "makalenizi beğendi.",
  has_published_a_new_article: "yeni bir makale yayınladı.",
  you: "Sen",
  all_views: "Tüm görüntülemeler",
  all_profile_views: "Tüm profil görüntülemeleri",
  mutual_company: "ortak şirket",
  artical_text: "Makale yaz...",
  you_have_appeared: "Göründünüz",
  your_request_at_the_company: "Şirketteki isteğiniz",
  times_you_have_appeared_in_searches: "aramalarda göründüğünüz kez",
  appear_more_often_in_searches: "Aramalarda daha sık görün",
  you_have_been_found: "Bulundunuz",
  improve_profile: "Profili iyileştir",
  choose_existing_contact_for_single_chat:
    "Tek sohbet için mevcut iletişimi seçin:",
  in_order_to_add_new_contacts:
    "Yeni iletişimler eklemek için lütfen profil sayfasında yeni iletişimler arayın.",
  times_in_searches_in_the_last_week:
    "geçen hafta aramalarda kez. Profilinizi güncelleyin ve daha kolay bulunmak için daha fazla detay ekleyin.",
  has_been_confirmed: "onaylandı.",
  have_joined_the: "katıldı  ",
  building_project: " inşaat projesi.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Temsil edeceğiniz şirketi seçin. Bu diğer katılımcılara gösterilecektir.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Temsil edeceğiniz şirketi seçin. Bu diğer katılımcılara gösterilecektir.",
  select_internal_section: "Lütfen dahili bölümü seçin",
  select_profile_image: "Profil resmini seç",
  share_user: "Kullanıcıyı paylaş",
  contact_sender_message:
    "Kjuup'un üye olmayan birini Kjuup'a davet etmek için bu bağlantıyı paylaşın. Bu bağlantı birden fazla kişi tarafından kayıt olmak için kullanılabilir.",
  project_sender_message:
    "Kjuup'un üye olmayan birini projeye davet etmek için bu bağlantıyı paylaşın. Bu bağlantı birden fazla kişi tarafından kayıt olmak ve Kjuup'ta projeye katılmak için kullanılabilir.",
  company_sender_message:
    "Kjuup'un üye olmayan birini şirket şirket adına davet etmek için bu bağlantıyı paylaşın. Bu bağlantı birden fazla kişi tarafından kayıt olmak ve Kjuup'ta şirkete katılmak için kullanılabilir.",
  contact_receivers_message:
    "Kjuup'a katılmak için davet bağlantısı. Lütfen kjuup için kayıt olmak üzere bağlantıya tıklayın.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "Kjuup'u Apple App Store üzerinden kuruyorsanız, kayıt olabilmek için başarılı indirmeden sonra bu bağlantıya tıklamanız gerekir.",
  project_receivers_message:
    "Kjuup'ta projeye katılmak için davet bağlantısı. Lütfen Kjuup için kayıt olmak ve projeye katılmak üzere bağlantıya tıklayın.",
  company_receivers_message:
    "Kjuup'ta şirket şirket adına davet bağlantısı. Lütfen Kjuup için kayıt olmak ve şirket şirket adına katılmak üzere bağlantıya tıklayın.",
  sign_in: "Giriş yap",
  enter_your_email_add: "E-posta adresinizi girin",
  forgot_password: "Şifrenizi mi unuttunuz?",
  dont_have_account: "Hesabınız yok mu?",
  register: "Kayıt ol",
  get_app: "Uygulamayı al",
  registration: "Kayıt",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Mimar",
  prof: "Prof.",
  first_name: "Ad",
  last_name: "Soyad",
  have_an_account: "Hesabınız var mı?",
  when_register_you_agree: "Kayıt olurken bizim",
  term_of_use: "kullanım şartlarımızı",
  to: "kabul edersiniz.",
  in_our: "Bizim",
  data_policy: "veri politikalarımızda",
  they_find_out: "öğrenebilirsiniz,",
  we_provide_store_data: "bilgileri nasıl topladığımızı, işlediğimizi ve sakladığımızı.",
  leaving_company_text:
    "Şirketten gerçekten ayrılmak istiyor musunuz? Şirketten ayrıldığınızda, tüm ilişkili projeler ve sohbet gruplarından da ayrılırsınız. Bu projelere başka bir şirketle istediğiniz zaman yeniden katılabilirsiniz.",
  delete_profile_text:
    "Profilinizi gerçekten silmek istiyor musunuz? Profilinizi sildiğinizde, şirketler, projeler ve sohbetlerle olan tüm bağlantılar kaldırılır. İstediğiniz zaman yeni bir profil oluşturabilirsiniz.",
  confirm: "Onayla",
  reject: "Reddet",
  requet_to_leave: "Ayrılma isteği",
  choose: "Seç",
  your_add_member: "Üye ekle",
  if_you: "eğer",
  can_not_find: "iletişiminizi burada bulamıyorsanız.",
  please_wait: "Lütfen bekleyin..",
  imprint_gtc: "Yasal bilgiler/Kullanım şartları",
  register_confirm_popup: "Giriş yapmadan önce Kjuup e-posta adresinizi doğrulayın. Onay bağlantısını gelen kutunuza gönderdik. Görmüyorsanız spam klasörünü kontrol edin.",
  PENDING_GROUP_USER:
    "proje davetinin onaylanmasından sonra mesaj alacaktır. Proje daveti onaylandığında ek bir mesaj görünecektir.",
  PENDING: "Proje davetinin onayı bekleniyor",
  denied_group_chat: " proje davetini reddetti ve bu gruptan ayrıldı.",
  // joined_group_chat: " odaya ve bu gruba katıldı.",
  joined_group_chat: " bu gruba katıldı",
  you_joined_group_chat: "Bu gruba katıldınız.",
  Others: "Diğerleri",
  LEFT_GROUP: "bu sohbet grubundan ayrıldı.",
  YOU_LEFT_GROUP: "bu sohbet grubundan ayrıldınız.",
  days: "gün",
  day: "gün",
  hour: "saat",
  hide_project: "Projeyi gizle",
  hide_project_popup_text:
    "Projeleri gizlerseniz, Kjuup içinde bulunamazlar. Sadece projenin üyeleri yeni kullanıcıları projeye davet edebilir.",
  branch: "Dal",
  photo_video_media_lib: "Fotoğraf - Video medya kütüphanesi",
  document: "Belge",
  location_meeting: "Konum / Toplantı",
  all_member_of_project: "Projenin tüm üyeleri",
  pending_request: "Bekleyen proje istekleri",
  no_pending_request: "Bekleyen istek bulunamadı!",
  news_feed: "Haber akışı",
  user_info: "Grup bilgisi",
  leave_project: "Projeyi terk et",
  media_link_docs: "Dosyalar",
  search_chat: "Sohbet ara",
  export_chat_group: "Geçen ayın sohbet grubu verilerini dışa aktar",
  request_complete_chat_history: "Tam sohbet geçmişini iste",
  leave_chat_group: "Sohbet grubundan ayrıl",
  add_user_project: "Kullanıcı ekle",
  me: "Ben",
  max_open_one_to_one:
    "Şu anda maks. 2 bire bir sohbet alt ve üst bölümde paralel olarak açılabilir. Toplamda maks. 4 bire bir sohbet mümkündür.",
  are_you_sure_you_want_leave_chat:
    "Bu sohbet grubundan ayrılmak istediğinizden emin misiniz?",
  create_group: "Grup oluştur",
  adding_members: "Üyeler ekleniyor...",
  creating_the_chat: "Sohbet oluşturuluyor...",
  finishing_setup: "Tamamlanıyor...",
  group_name: "Grup adı",
  by: "Tarafından:",
  mandetory: "*zorunlu",
  delteed: "profilini sildi ve grup sohbetinden ayrıldı.",
  deleted_direct: "profilini sildi ve sohbetten ayrıldı.",
  unhidden_message:
    "Projeleri gizlemezseniz, Kjuup'un tüm üyeleri tarafından bulunabilirler.",
  account_deleted: "Hesap silindi.",
  refuse_company: "Şirket davetini reddetmek istediğinizden emin misiniz?",
  follow_additional: "Ek kullanıcıları takip et",
  f_add:
    "Doğrudan mesajlar için kullanılabilir hale getirmek için Kjuup'un ek kullanıcılarını takip edin.",
  c_inv: "Şirket daveti(leri)",
  invited_o_Company: "Şirkete katılmaya davet edildiniz",
  refuse_companyX: "Şirket isteğini reddetmek istediğinizden emin misiniz?",
  a_Da: "Hesap devre dışı bırakıldı.",
  has_deactivated: "profilini devre dışı bıraktı.",
  reactive: "profilini yeniden etkinleştirdi.",
  juup_note: "*Kullanıcı adı ile kayıt sadece Kjuup+ üyeleri için mevcuttur",
  username: "Kullanıcı adı*",
  email_username: "E-posta/Kullanıcı adı*",
  sPinText:
    "Lütfen 6 haneli bir güvenlik pin'i sağlayın. Bu pin şifrenizi unutmanız durumunda gerekli olacak ve hesabınızı onaylamak için zorunludur.",
  DeleteKjuupPlusText:
    "Profilinizi gerçekten silmek istiyor musunuz? Profilinizi sildiğinizde, şirketler, projeler ve sohbetlerle olan tüm bağlantılar kaldırılır.\n\nHesap silinmesinden sonraki 48 saat içinde kullanıcı adı, şifre ve pin ile giriş yaparak hesabınızı yeniden etkinleştirebilirsiniz.",
  reactive_text:
    "Hesabınız silindi. Lütfen hesabınızı yeniden etkinleştirmek için Yeniden Etkinleştir'e tıklayın.",
  rac: "Yeniden etkinleştir",
  ac_ss: "Hesap başarıyla yeniden etkinleştirildi.",
  not_valid_pin: "Pin geçersiz",
  only_for_kjuup:
    "*Kullanıcı adı ve pin ile şifre sıfırlama sadece Kjuup+ üyeleri için mevcuttur.",
  resetPIN: "PIN'i sıfırla",
  enter_current_pin: "Lütfen mevcut PIN'inizi girin",
  enter_new: "Yeni PIN girin",
  pin_to_confirm: "Lütfen onaylamak için PIN'i sağlayın.",
  change_username: "Kullanıcı adını sıfırla",
  pp_not_match: "Şifre ve Şifre Onayı eşleşmiyor",
  reactive_itself: "Profilinizi yeniden etkinleştirdiniz.",
  has_deactivated_itself: "Profilinizi devre dışı bıraktınız.",
  more_than_two:
    "Şu anda doğrudan mesajlar sadece 2 kullanıcıyla paralel olarak yapılabilir.",
  Chats: "Doğrudan mesajlar",
  only_in_mobileL:
    "Yerel videolar şu anda sadece mobil uygulama üzerinden yüklenebilir ve yayınlanabilir. Lütfen Youtube ve Vimeo'nun video bağlantılarını kullanın.",
  register_pin_text:
    "Lütfen kişisel 6 haneli PIN'inizi seçin. Bu PIN hesap sıfırlama işlevlerini etkinleştirmek için gerekli olacaktır.",
  internal_project: "Dahili",
  external_projects: "Harici",
  in_deacticted: "Dahili bölüm devre dışı bırakıldı.",
  create_article: "Makale oluştur",
  new_article_selection: "Harici haber akışı için makale oluştur",
  new_article_selection_internal: "Dahili makale oluştur",
  active_trans_title: "Otomatik çeviriyi etkinleştirmek istiyor musunuz?",
  active_trans: "Etkinleştirildiğinde, tüm gelen sohbet mesajları seçtiğiniz uygulama diline çevrilecektir.",
  disable_trans: "Otomatik çeviriyi gerçekten devre dışı bırakmak istiyor musunuz?",
  allow_access_chat: "Tam sohbet geçmişini göster",
  toggle_chat_history_on:
    "Kullanıcının tam sohbet geçmişini görmesini gerçekten istiyor musunuz?",
  toggle_chat_history_off:
    "Kullanıcının sadece sohbete katılma noktasından itibaren sohbet geçmişini görmesini gerçekten istiyor musunuz?",
  check_selected_settings:
    "Lütfen seçili tüm kullanıcılar için sohbet geçmişi ayarlarını kontrol edin!",
  chat_from_start_have:
    "Bu gruba katıldınız. Sohbet geçmişi paylaşıldı.",
  chat_from_start_has:
    "bu gruba katıldı. Sohbet geçmişi paylaşıldı.",
  Address: "Adres",
  read_by: "Okuyan",
  deliver_to: "Teslim edilen",
  remaining: "kalan",
  message_info: "Mesaj bilgisi",
  request_to_join_only: "Katılma isteği",
  unfollow: "Takibi bırak",
  company_username: "Kullanıcı adı",
  month: [
    "Oca",
    "Şub",
    "Mar",
    "Nis",
    "May",
    "Haz",
    "Tem",
    "Ağu",
    "Eyl",
    "Eki",
    "Kas",
    "Ara",
  ],
  remove_my_admin_right: "Yönetici haklarımı kaldır",
  makeEmp: "Kullanıcıdan şirket yönetici haklarını gerçekten kaldırmak istiyor musunuz?",
  remove_my_self:
    "Hesabınızdan şirket yönetici haklarını gerçekten kaldırmak istiyor musunuz?",
  makeAdmin: "Kullanıcıya şirket yönetici hakları vermek istediğinizden emin misiniz?",
  remove_member: "Üye kaldır",
  remove_following_confirm: "{name} takip listesinden kaldırmak istediğinize emin misiniz?",
  remove_follower_confirm: "{name} sizi takip edenler listesinden kaldırmak istediğinize emin misiniz? Kaldırırsanız kendisine bilgi verilmeyecektir.",
  do_you_really_want_to_remove:
    "Kullanıcı adını şirketten gerçekten kaldırmak istiyor musunuz?",
  invite_all: "Şirketin tüm üyelerini davet et",
  invite_all_members: "Tüm üyeleri davet et",
  mems: "Diğer tüm üyeler",
  dep_loc: "Departman/Konum/Takım",
  depAdmin: "Departman yöneticisi",
  add_remove_admin: "Şirket yönetici pozisyonu ekle/kaldır",
  add_remove_dep_admin: "Departman yönetici pozisyonu ekle/kaldır",
  remove_employees_dept: "Çalışanları kaldır",
  want_to_join_dep:
    "Kullanıcı adı şirket şirket adının Departman/Konum/Takım depname'ine katılmak istiyor.",
  you_invited:
    "Şirket şirket adının Departman/Konum/Takım depname'ine katılmaya davet edildiniz.",
  dep_remove:
    "Kullanıcıdan departman veya konum yönetici haklarını gerçekten kaldırmak istiyor musunuz?",
  add_dep:
    "Kullanıcıya departman veya konum için yönetici hakları vermek istediğinizden emin misiniz?",
  my_self_dep_remove:
    "Hesabınızdan departman yönetici haklarını gerçekten kaldırmak istiyor musunuz?",
  member: "Üye",
  admin: "Yönetici",
  remove_project_admin:
    "Üyeyi projeden gerçekten kaldırmak istiyor musunuz?",
  remove_my_self_project: "Yönetici haklarını gerçekten kaldırmak istiyor musunuz?",
  remove_member_admin_right:
    "Kullanıcıdan yönetici haklarını gerçekten kaldırmak istiyor musunuz?",
  add_member_admin_right: "Kullanıcıya yönetici hakları eklemek istediğinizden emin misiniz?",
  add_remove_Poss: "Yönetici pozisyonu ekle/kaldır",
  forward: "İlet",
  forward_to: "Şuraya ilet...",
  edit: "Düzenle",
  only_kjuup_plus_can: "Sadece Kjuup+ şirketleri makale yayınlayabilir.",
  add_images: "Resim(ler) ekle",
  request_confirmation: 'Bekleyen proje davetleri',
  Activity: "Aktivite",
  latest_messages: "En son mesajlar",
  hours: "saat",
  minute: "dakika",
  seconds: "saniye",
  days: "gün",
  yesterday: "dün",
  last_week: "geçen hafta",
  next_week: "gelecek hafta",
  Last_month: "geçen ay",
  All: "Tümü",
  register_plus: "Kayıt Plus",
  select_files: "Dosya seç",
  monthsFullName: [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık",
  ],
  company_deploc_receivers_message:
    "Kjuup'ta şirket şirket adının departmanına davet bağlantısı. Lütfen Kjuup için kayıt olmak ve şirket şirket adına katılmak üzere bağlantıya tıklayın.",
  no_news: "Haber mevcut değil",
  reminder: "Hatırlatıcı",
  np_reminder: "Yapılacak yok",
  move_to_reminder: "Yapılacaklara taşı",
  remove_reminder: "Bu mesajı yapılacaklar listenizden gerçekten kaldırmak istiyor musunuz?",
  remove_all_reminder: "Tüm yapılacakları kaldır",
  remove_all_confirm: "Tüm mesajları yapılacaklar listenizden gerçekten kaldırmak istiyor musunuz?",
  remove_from_reminder: "Hatırlatıcıdan kaldır",
  prevent_email: "E-posta kullanıcı adı olarak kullanılamaz.",
  allow_noti: "Lütfen bildirimlere izin verin.",
  join_cap: "Katıl",
  pass_minimum:
    "**Şifre küçük harf, büyük harf, rakam ve özel karakter dahil 12 karakter gerektirir.",
  pass_error: "Lütfen şifre gereksinimlerini kontrol edin",
  people_that_like_article: "Makaleyi beğenen kişiler.",
  people_who_like_article: "Makalenizi beğenen kişiler.",
  message_delete: "Bu mesaj silindi.",
  message_edited: "düzenlendi",
  edit_message: "Mesajı düzenle",
  edit_window_expired: "Mesajlar yalnızca gönderildikten sonraki 10 dakika içinde düzenlenebilir.",
  message_edit_save: "Kaydet",
  copy: "Kopyala",
  bookmark: "Yer imi",
  add_reaction: "Tepki ekle",
  delete_message: "Mesajı sil",
  more_options: "Diğer seçenekler",
  info: "Bilgi",
  link_invite: "Bağlantı ile davet et",
  ll_nkk: "Kjuup'a davet et",
  selected: "Seçili",
  is_active: "Aktif",
  inactive: "Pasif",
  last_online: "son görülme {{when}}",
  remove_user_l: "Kaldır",
  link_expire: "Oluşturulan her bağlantı 72 saat geçerli olacaktır.",
  company_language: "Şirket dili",
  company_language_info:
    "Dil seçimi şirketle ilgili tüm e-posta onayları için kullanılacaktır.",
  s_image: "resim",
  m_image: "resimler",
  removeMsg: "Kaldırmak için dokunun",
  block: 'Engelle',
  unblock: 'Engeli kaldır',
  blocks: 'Bu kullanıcıyı engellemek istediğinizden emin misiniz?',
  unblocks: 'Bu kullanıcının engelini kaldırmak istediğinizden emin misiniz?',
  bolcked_click_un_block:
    'Bu iletişimi engellediniz. Engeli kaldırmak için buraya tıklayın.',
  you_have_unblocked: 'Bu iletişimin engelini kaldırdınız.',
  you_have_blocked: 'Bu iletişimi engellediniz.',
  unblock_to_send: 'Mesaj göndermek için kullanıcının engelini kaldırın.',
  pilot_text: "İnşaat konuları için özelleştirilmiş AI",
  startup_screen_label: "Başlangıç ekranı",
  startup_screen_info: "Kjuup başladığında hangi ekranın açılacağını seçin.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Mesajlar",
  startup_screen_saved: "Başlangıç ekranı güncellendi",
email_on: "E-posta bildirimi sohbetleri",
  email_on_grp: "E-posta bildirimi",
  article_email_on: "Makale e-posta bildirimleri",
  article_email_info: "Dahili makaleler için e-posta bildirimlerini etkinleştirirseniz, şirketinizde ve departmanınızda yeni bir dahili makale yayınlandığında bir e-posta alırsınız.",
  info_email_room: "Bu proje için e-posta bildirimlerini etkinleştirin veya devre dışı bırakın. Bu seçenek sadece kişisel ayarlar üzerinden \"E-posta bildirimi sohbetleri\" etkinleştirildiğinde mevcuttur.",
  todo_notification_info: "Size yeni bir görev atandığında bildirim alırsınız.",
  info_val: "Yeni bir sohbet mesajı kısa süre içinde okunmazsa bir e-posta alırsınız. Bunu belirli projeler veya sohbetler için ilgili ayarlarda ya da sohbet grubu bilgisinde kapatabilirsiniz.",
  email_groups: "Bu sohbet için e-posta bildirimlerini etkinleştirin veya devre dışı bırakın. Bu seçenek sadece kişisel ve proje ayarları üzerinden \"E-posta bildirimi sohbetleri\" etkinleştirildiğinde mevcuttur.",
  add_update_email: "E-posta ekle/güncelle",
  text_to_verifiy: "\"E-posta bildirimi sohbetleri\" seçeneği sadece dosyada doğrulanmış bir e-posta adresiniz varsa etkinleştirilebilir.",
  stored_email: "Kayıtlı e-posta: ",
  verify_email: "Onay bekleniyor!",
  join_call:"Katıl",
  call_is_started:"Arama başlatıldı",
  start_chat:"Doğrudan sohbet başlat?",
  project_rooms:"Projeler",
  download_selected:"İndir",
  add_employee_confirm: 'Bu kullanıcıyı şirkete eklemek istediğinizden emin misiniz?',
  invalid_deeplink: "Geçersiz derin bağlantı URL'si. Gerekli parametreler eksik.",
  deeplink_error: "Derin bağlantı işlenemedi. Lütfen daha sonra tekrar deneyin.",
  // Reply functionality translations
  reply: "Yanıtla",
  reply_enter: "Yanıt girin...",
  reply_sent_successfully: "Yanıt başarıyla gönderildi",
  reply_failed: "Yanıt gönderme başarısız",
  reply_failed_generic: "Yanıt gönderme başarısız. Lütfen tekrar deneyin.",
  replying_to_message: "Mesaja yanıt veriliyor",
  cancel_reply: "Yanıtı iptal et",
  voice_message: "Sesli mesaj",
  send: "Gönder",
  cancel: "İptal",
  type_your_reply: "Yanıtınızı yazın...",
  
  // Auto-suggestion translations
  suggested_replies: "Önerilen yanıtlar",
  suggestions_error: "Öneriler yüklenemedi",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Görsel — Yüklemek için tıklayın",
  lazy_media_audio: "Sesli mesaj — Yüklemek için tıklayın",
  lazy_media_doc: "Belge — Yüklemek için tıklayın",
  lazy_media_video: "Video — Yüklemek için tıklayın",
  suggestion_loading_message: "Bir dakika. Metniniz sizin için bireysel olarak hazırlanıyor.",
  loading_chat_message: "Sohbet yükleniyor...",
  
  // Manual ToDo translations
  extracting_message: "Mesaj çıkarılıyor...",
  create_todo: "Yapılacak oluştur",
  create_todo_confirmation: "Bu mesajdan bir yapılacak oluşturmak istiyor musunuz?",
  select_project_required: "Lütfen bir proje/grup seçin",
  only_assigned_can_change_status: "Sadece atanan kullanıcılar durumu değiştirebilir",
  todo_summary: "Özet",
  todo_summary_placeholder: "Yapılacak özetini girin...",
  todo_date: "Tarih",
  todo_time: "Saat",
  todo_date_hint: "Orijinal mesaj tarih/saatini kullanmak için boş bırakın",
  todo_created_success: "Yapılacak başarıyla oluşturuldu",
  todo_creation_failed: "Yapılacak oluşturma başarısız",
  create: "Oluştur",
  
  image: "resim",
  images: "resimler",
  remove_all_images: "Tüm resimleri kaldır",
  remove_image: "Resmi kaldır",
  remove_document: "Belgeyi kaldır",
  remove_recording: "Kaydı kaldır",
  play_recording: "Kaydı oynat",
  upload_image: "Resim yükle",
  upload_document: "Belge yükle",
  record_audio: "Ses kaydet",
  stop_recording: "Kaydı durdur",
  stop_recording_text: "Kaydı durdur",
  please_remove_current_attachment: "Lütfen mevcut eki kaldırın",
  please_upload_image_file: "Lütfen geçerli bir resim dosyası yükleyin",
  please_upload_valid_document: "Lütfen geçerli bir belge dosyası yükleyin",
  searching_messages: "Mesajlar aranıyor...",
  loading_more: "Daha fazla yükleniyor...",
  loading_more_users: "Daha fazla kullanıcı yükleniyor...",
  load_more_users: "Daha fazla kullanıcı yükle",
  no_more_users_to_load: "Yüklenecek daha fazla kullanıcı yok",
  no_messages_found: "Mesaj bulunamadı",
  try_different_keyword: "Farklı bir anahtar kelime deneyin veya yazımınızı kontrol edin.",
  search_messages: "Mesajları, sohbet gruplarını, projeleri ve kullanıcıları ara...",
  todo: "Yapılacak",
  np_todo: "Yapılacak yok",
  move_to_todo: "Yapılacak olarak kaydet",
  remove_todo: "Yapılacakları gerçekten kaldırmak istiyor musunuz?",
  remove_all_todo: "Tüm yapılacakları kaldır",
  remove_all_todo_confirm: "Tüm yapılacakları gerçekten kaldırmak istiyor musunuz?",
  add_to_todo: "Yapılacaklara ekle",
  remove_from_todo: "Yapılacaklardan kaldır",
  confirm: "Onayla",
  ok: "Tamam",
  read_more: "Daha fazla oku",
  show_less: "Daha az göster",
  show_more: "Daha fazla göster",
  audio: "Ses",
  video: "Video",
  // Notification Settings
  notification_schedule: "Bildirim programı",
  notification_schedule_desc: "Sadece seçtiğiniz saatlerde push ve e-posta bildirimleri alacaksınız. Bu saatlerin dışında bunlar duraklatılacaktır.",
  learn_more: "Daha fazla bilgi",
  allow_notifications: "Bildirimlere izin ver:",
  every_day: "Her gün",
  weekdays: "Hafta içi (Pazartesi - Cuma)",
  custom: "Özel",
  monday: "Pazartesi",
  tuesday: "Salı",
  wednesday: "Çarşamba",
  thursday: "Perşembe",
  friday: "Cuma",
  saturday: "Cumartesi",
  sunday: "Pazar",
  to: "ile",
  notification_settings: "Bildirimler",
  notification_settings_saved: "Bildirim ayarları başarıyla kaydedildi",
  notification_settings_error: "Bildirim ayarları kaydedilemedi",
  unavailability_note: "Müsaitlik notu",
  unavailability_description: "Ofis dışı notu ayarlayın. Aktif olduğu sürece, not tüm sohbetlerinizde diğerlerine gösterilir ve bildirimler duraklatılır.",
  unavailability_start_date: "Başlangıç tarihi",
  unavailability_end_date: "Bitiş tarihi",
  unavailability_message: "Mesaj",
  unavailability_message_hint: "Dönüş tarihiniz için {endDate} yer tutucusunu kullanın.",
  unavailability_replacement: "Yedek kişi",
  unavailability_replacement_placeholder: "Acil istekler için kullanıcı kimliğini girin",
  unavailability_replacement_current: "Mevcut yedek",
  unavailability_replacement_hint: "Ayarlanırsa, acil konular için bu kişiyle iletişime geçmek üzere bir bağlantı müsaitlik notunuzda gösterilir.",
  unavailability_replacement_none: "Yedek yok (isteğe bağlı)",
  unavailability_contact_urgent: "Acil istekler için iletişime geçin",
  unavailability_default_message: "Şu anda ofiste değilim ve Kjuup'a erişimim yok. {endDate} tarihinden itibaren tekrar ulaşılabilir olacağım ve sizinle iletişime geçeceğim.",
  unavailability_save: "Kaydet",
  unavailability_deactivate: "Devre dışı bırak",
  unavailability_active_until: "Şu tarihe kadar aktif",
  unavailability_saved: "Müsaitlik notu kaydedildi",
  unavailability_save_error: "Müsaitlik notu kaydedilemedi",
  unavailability_deactivated: "Müsaitlik notu devre dışı bırakıldı",
  unavailability_end_date_required: "Bitiş tarihi zorunludur",
  start_time_before_end_time: "Başlangıç saati bitiş saatinden önce olmalıdır",
  loading: "Yükleniyor",
  disabled: "Devre dışı",
  enable: "Etkinleştir",
  disable: "Devre dışı bırak",
  forwarded: "İletildi",
  message_forwarded: "Mesaj iletildi!",
  // Schedule Article
  schedule_article_post: "Makale yayınını planla",
  date: "Tarih",
  time: "Saat",
  scheduled_for_publication: "Yayın için planlandı",
  article_will_be_published_on: "Makale şu tarihte yayınlanacak:",
  reset_selection: "Seçimi sıfırla",
  continue: "Devam et",
  cancel: "İptal",
  // Member Selection
  error_loading_members: "Üyeler yüklenirken hata",
  please_fill_all_fields: "Lütfen tüm alanları doldurun",
  invalid_email: "Geçersiz e-posta adresi",
  member_added_successfully: "Üye başarıyla eklendi",
  error_onboarding_user: "Kullanıcı eklenirken hata",
  error_creating_chat: "Sohbet oluşturulurken hata",
  error_creating_group: "Grup oluşturulurken hata",
  new_group: "Yeni grup",
  please_select_or_enter_group_name: "Lütfen bir grup seçin veya grup adı girin",
  please_select_or_enter_room_name: "Lütfen bir proje seçin veya proje adı girin",
  error_creating_room: "Proje oluşturulurken hata",
  error_opening_chat: "Sohbet açılırken hata",
  privacy_modal_text: "Sohbet proje yöneticisi için ilgili profesyonel içerik içermiyorsa sadece \"Özel\" seçin.",
  not_private: "Özel değil",
  private: "Özel",
  error_loading_groups: "Gruplar yüklenirken hata",
  automatic_chat_export: "Otomatik sohbet dışa aktarma",
  automatic_chat_export_info: "Etkinleştirildikten sonra, sohbet geçmişi her ay belirtilen e-posta adresine otomatik olarak gönderilecektir.",
  automatic_chat_export_no_email: "Otomatik sohbet dışa aktarmayı etkinleştirmek için önce bir e-posta adresi eklemeniz gerekir. E-posta adresinizi kişisel ayarlardan ekleyebilirsiniz.",
  enter_email: "E-posta girin",
  update: "Güncelle",
  confirm: "Onayla",
  export_to_email: "Dışa aktarma aşağıdaki e-postaya gider.",
  start_chat_button:"Yeni mesaj",
  matching_existing_chats: "Eşleşen mevcut sohbetler",
  subject: "Konu",
  add_subject: "Konu ekle",
  chat_subject: "Sohbet konusu:",
  set_project_room: "Projeyi ayarla",
  matching_existing_project_rooms: "Eşleşen mevcut projeler",
  name_project_room: "Projeyi adlandır",
  professional_or_private: "Profesyonel veya özel",
  professional: "Profesyonel",
  privacy_modal_text_updated: "Sohbet proje yöneticileri için ilgili profesyonel içerik içermiyorsa sadece \"Özel\" seçin. Özel sohbetler proje yöneticilerine görünmez.",
  create_internal_chat: "Harici - veya dahili sohbet?",
  internal_chat_description: "Sadece şirketinizin çalışanları dahili sohbetlere eklenebilir.",
  yes: "Evet",
  no: "Hayır",
  chat_is_being_created: "Sohbet oluşturuluyor...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Bu makaledeki değişiklikleri gerçekten iptal etmek istiyor musunuz?",
  please_enter_article_title: "Lütfen önce makale başlığını girin.",
  please_add_mandatory_fields: "Lütfen tüm zorunlu alanları ekleyin",
  product_label: "Ürün:",
  no_companies_found: "Şirket bulunamadı",
  visible_to_all_followers: "Tüm Kjuup üyelerine görünür",
  only_visible_to_employees: "Sadece çalışanlara görünür",
  something_went_wrong: "Bir şeyler yanlış gitti, lütfen tekrar deneyin",
  please_select_department: "Lütfen departman/konum seçin",
  schedule: "Planla",
  please_select_future_date_time: "Lütfen makaleyi planlamak için gelecek bir tarih ve saat seçin.",
  please_select_different_date_time: "Lütfen makaleyi planlamak için farklı bir tarih veya saat seçin.",
  please_select_later_time: "Lütfen bugün için mevcut saatten daha sonra bir saat seçin.",
  unpin_article: "Makaleyi sabitlemeyi kaldır",
  pin_article: "Makaleyi sabitle",
  and: "ve",
  others: "diğerleri",
  at: "saat",
  // Chat mute/unmute translations
  mute: "Sessize al",
  unmute: "Sesi aç",
  chat_muted_successfully: "Sohbet başarıyla sessize alındı",
  chat_unmuted_successfully: "Sohbet sesi başarıyla açıldı",
  mute_chat_confirm: "Bu sohbeti gerçekten sessize almak istiyor musunuz? Artık yeni mesajlar için bildirim almayacaksınız.",
  unmute_chat_confirm: "Bu sohbetin sesini gerçekten açmak istiyor musunuz? Yeni mesajlar için tekrar bildirim alacaksınız.",
  please_select_group_to_forward: "Lütfen mesajı iletmek için grup seçin",
  // Company translations
  record_not_found: "Kayıt bulunamadı!",
  please_select_position: "Lütfen pozisyon seçin",
  delete_article_confirm: "Bu makaleyi silmek istediğinizden emin misiniz?",
  delete_company_service_confirm: "Şirket hizmetini silmek istediğinizden emin misiniz?",
  block_translation_confirm: "Şirketin tüm üyeleri için projelerde otomatik çeviriyi gerçekten engellemek istiyor musunuz",
  unblock_translation_confirm: "Şirketin tüm üyeleri için projelerde otomatik çeviriyi gerçekten engelini kaldırmak istiyor musunuz",
  please_select_file: "Lütfen yüklemek için bir dosya seçin",
  role_in_building_industry: "İnşaat sektöründeki rol*",
  invalid_email_address: "Geçersiz e-posta adresi",
  please_enter_password: "Lütfen şifre girin",
  password_change_email_sent: "Kjuup e-posta adresinize bir e-posta gönderildi. E-postadaki onay bağlantısına tıklayarak yeni şifrenizi onaylayın.",
  please_enter_username: "Lütfen kullanıcı adı girin",
  username_same_as_before: "Kullanıcı adı öncekiyle aynı olamaz",
  profile_deleted_successfully: "Profil başarıyla silindi",
  hardware_requirements: "Donanım gereksinimleri",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU hızı min. 2GHz<br/>• Windows 7 veya üzeri / tüm macOS sürümleri",
  submitting: "Gönderiliyor...",
  signing_in: "Giriş yapılıyor...",
  please_enter_service_name: "Lütfen hizmet adını girin",
  something_went_wrong_error: "Aaaah! Bir şeyler yanlış gitti...",
  something_went_wrong_try_again: "Üzgünüm, orada bir şeyler yanlış gitti. Tekrar deneyin",
  position_label: "Pozisyon:",
  loading_room: "Proje yükleniyor...",
  navigating_to_room: "Projeye gidiliyor",
  loading_chat: "Sohbet yükleniyor...",
  translate: "Çevir",
  show_original: "Orijinali göster",
  saving: "Kaydediliyor...",
  language_selection_info: "Dil seçimi şirketle ilgili tüm e-posta onayları için kullanılır.",
  // Navigation bar labels
  nav_call: "Ara",
  nav_home: "Ana sayfa",
  nav_messages: "Mesajlar",
  nav_todo: "Yapılacaklar",
  nav_rooms: "Projeler",
  nav_all_rooms: "Tüm Projeler",
  pinned_rooms_max: "En fazla 10 proje sabitleyebilirsiniz.",
  pinned_room_unpin: "Kaldır",
  pinned_rooms_drop: "Hızlı seçim için projenizi buraya sürükleyin",
  nav_profile: "Profil",
  nav_company: "Şirket",
  nav_company_documents: "Belgeler",
  nav_logout: "Çıkış yap",
  // Create message dialog
  add_member_title: "Üye ekle",
  continue_btn: "Devam et",
  search_placeholder: "Ara",
  no_members_found: "Üye bulunamadı",
  no_groups_found: "Grup bulunamadı",
  no_rooms_found: "Proje bulunamadı",
  search_users_tab: "Kullanıcılar",
  search_documents_tab: "Belgeler",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Dosya yok",
  no_documents_available: "No documents",
  searching_users: "Kullanıcılar aranıyor...",
  no_users_found: "Kullanıcı bulunamadı",
  search_emails_tab: "E-posta",
  searching_emails: "E-postalar aranıyor...",
  no_emails_found: "E-posta bulunamadı",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "İsimsiz grup",
  unnamed_room: "İsimsiz proje",
  all_members: "Tümü",
  room_label: "Proje:",
  subject_label: "Konu:",
  no_members: "Üye yok",
  // Loading states for room creation
  creating_structure: "Yapınız oluşturuluyor",
  opening_chat: "Sohbet açılıyor",
  please_wait: "Lütfen bekleyin...",
  // ToDo page translations
  loading_todo: "ToDo yükleniyor...",
  task_updated: "Görev güncellendi",
  error_updating_task: "Görev güncellenirken hata",
  task_deleted: "Görev silindi",
  error_deleting_task: "Görev silinirken hata",
  delete_task_confirm: "Bu görevi silmek istediğinizden emin misiniz?",
  description_label: "Açıklama",
  description_placeholder: "Açıklama girin...",
  date_time_label: "Tarih ve saat",
  save_hint: "Kaydetmek için Ctrl+Enter, iptal etmek için Esc",
  edit_label: "Düzenle",
  delete_label: "Sil",
  todo_list_title: "Yapılacaklar",
  tasks_count: "görev",
  search_placeholder_todo: "Ara...",
  select_task_to_open_chat: "Sohbeti açmak için bir görev seçin",
  today: "Bugün",
  yesterday: "Dün",
  time_suffix: "", // Empty for Turkish (24h format doesn't need suffix)
  from_chat: "Kaynak yapılacak",
  assigned_to: "Atanan",
  assign_users: "Kullanıcıları ata",
  no_users_assigned: "Atanan kullanıcı yok",
  assign: "Ata",
  assign_to: "Ata...",
  navigate_to_chat: "Sohbete git",
  navigate_to_email: "E-postaya git",
  show_original_message: "Kaynağı göster",
  hide_original_message: "Kaynağı gizle",
  status_pending: "Beklemede",
  status_in_progress: "Devam ediyor",
  status_completed: "Tamamlandı",
  show: "Göster",
  close: "Kapat",
  status_confirmed: "Onaylandı",
  log_todo_created: "Yapılacak oluşturuldu",
  log_todo_confirmed: "Yapılacak onaylandı",
  log_todo_deleted: "Yapılacak silindi",
  log_todo_updated: "Yapılacak güncellendi",
  log_description_updated: "Açıklama güncellendi",
  log_deadline_updated: "Son tarih güncellendi",
  log_assigned_to: "{name} atandı",
  log_unassigned_from: "{name} atanmadı",
  log_assignment_added: "Atama eklendi: {name}",
  log_assignment_removed: "Atama kaldırıldı: {name}",
  log_status_updated: "Durum {from} ile {to} arasında değiştirildi",
  log_status_changed: "Durum değiştirildi",
  log_status_changed_to: "Durum {status} olarak değiştirildi",
  log_changed_status_to: "Durumu şu şekilde değiştirdi:",
  log_for_user: "kullanıcı için:",
  log_user_updated_status: "Kullanıcı yapılacak durumunu güncelledi",
  log_changed_date_to: "Tarihi şu şekilde değiştirdi:",
  log_changed_description_to: "Açıklamayı şu şekilde değiştirdi:",
  log_moved_to: "{status} taşındı",
  todo_status_updated_from: "şuradan",
  todo_status_updated_to: "şuraya",
  filter_pending: "Beklemede",
  filter_confirmed: "Onaylandı",
  filter_assigned_to_me: "Görevlerim",
  filter_assigned_by_me: "Devredilen",
  todo_project_label: "Proje:",
  assigned_users: "Atanan kullanıcılar:",
  todo_chat_label: "Sohbet:",
  history: "Geçmiş",
  todo_assigned_by: "Atayan:",
  todo_assigned_push: "Atanan ToDo:",
  todo_assigned_push_empty: "Size yeni bir ToDo atandı.",
  search_groups: "Gruplar",
  search_chat_groups: "Sohbet grupları",
  search_project_room: "Proje",
  search_messages_tab: "Mesajlar",
  searching_groups: "Gruplar aranıyor...",
  searching_rooms: "Projeler aranıyor...",
  no_groups_found: "Grup bulunamadı",
  no_rooms_found: "Proje bulunamadı",
  create_poll: "Anket",
  poll_question_label: "SORU",
  poll_question_placeholder: "Bir soru sorun",
  poll_options_label: "SEÇENEKLER",
  poll_option: "Seçenek",
  poll_add_option: "Seçenek ekle",
  poll_allow_multiple: "Birden fazla yanıta izin ver",
  poll_multiple_allowed: "Bir veya daha fazla seçenek belirleyin",
  poll_select_option: "Bir seçenek belirleyin",
  poll_view_votes: "Oyları görüntüle",
  poll_vote_singular: "oy",
  poll_vote_plural: "oy",
  poll_votes: "Anket sonuçları",
  poll_no_votes_yet: "Henüz oy yok",
  transcript_step_processing: "Transkripsiyon devam ediyor...",
  ai_transcript_tab: "AI-Transkripsiyon",
  ai_transcript_info: "Yalnızca 09.03.2026 tarihinden sonra oluşturulan sesli mesajlar için kullanılabilir.",
  transcript_more: "...daha fazla",
  transcript_less: "...daha az",
  ki_transcript_voice_message: "KI-Sesli mesaj transkripsiyonu",
  ki_image_analysis: "Yapay zeka destekli görüntü analizi",
  type_message: "Bir mesaj yazın",
  email_tab_messages: "Mesajlar",
  email_tab_email: "E-posta",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "E-posta hesapları",
  email_connect_gmail: "Gmail Bağla",
  email_connect_outlook: "Outlook Bağla",
  email_no_accounts: "Bağlı e-posta hesabı yok",
  email_no_accounts_hint: "Profil ayarlarınızda bir e-posta hesabı bağlayın",
  email_no_messages: "E-posta yok",
  email_from: "Kimden",
  email_to: "Kime",
  email_subject: "Konu",
  email_disconnect: "Bağlantıyı kes",
  email_disconnect_confirm: "Bu e-posta hesabının bağlantısını kesmek istediğinizden emin misiniz? Tüm senkronize edilmiş e-postalar kaldırılacaktır.",
  email_account_disconnected: "E-posta hesabı başarıyla bağlantısı kesildi",
  email_account_disconnect_failed: "Hesap bağlantısı kesilemedi",
  email_connecting: "Bağlanıyor...",
  email_account_connected: "Hesap başarıyla bağlandı",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Ayarlara git",
  email_date: "Tarih",
  email_reply: "Yanıtla",
  email_forward: "İlet",
  email_copy_text: "Metni kopyala",
  email_text_copied: "Kopyalandı!",
  email_text_copy_failed: "Metin kopyalanamadı.",
  email_delete: "Sil",
  email_not_spam: "Spam Değil",
  email_not_spam_success: "E-posta gelen kutusuna taşındı.",
  email_not_spam_failed: "Gelen kutusuna taşıma başarısız oldu.",
  email_delete_confirm: "Bu e-postayı silmek istediğinizden emin misiniz?",
  email_delete_from_folder: "{folder} klasöründen silmek istediğinizden emin misiniz?",
  email_delete_permanent_from_folder:
    "{folder} klasöründen kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
  email_save_draft_confirm: "Bu e-postayı taslak olarak kaydetmek istiyor musunuz?",
  email_save_draft: "Taslak Kaydet",
  email_discard: "Sil",
  email_back_to_compose: "Yazmaya dön",
  email_draft_saved: "Taslak kaydedildi.",
  email_draft_save_failed: "Taslak kaydedilemedi.",
  email_loading: "E-postalar yükleniyor...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Seç",
  email_attachment_singular: "Ek",
  email_attachment_plural: "Ekler",
  email_back: "Geri",
  email_download: "İndir",
  email_close: "Kapat",
  email_preview: "Önizleme",
  email_preview_not_available: "Önizleme mevcut değil",
  email_preview_failed: "Önizleme mevcut değil",
  select_attachments: "Ekleri seç",
  email_loading_preview: "Önizleme yükleniyor...",
  email_mark_unread_failed: "e-posta okunmadı olarak işaretlenemedi.",
  email_delete_failed: "e-posta silinemedi.",
  filter_all: "Tümü",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Doğrudan mesajlar",
  my_notes: "My Space",
  filter_internal_groups: "Dahili grup sohbetleri",
  filter_external_groups: "Harici grup sohbetleri",
  filter_group_chats: "Grup sohbetleri",
  filter_groups_internal: "Dahili",
  filter_groups_external: "Harici",
  filter_unread_only: "Sadece okunmamış",
  room_daily_briefing_info: "Etkinleştirildiğinde, bu proje için rapor kişisel ayarlarınızda belirtilen saatte her 24 saatte bir oluşturulur — ancak yalnızca o dönemde etkinlik olduysa.",
  email_select_all: "Tümünü seç",
  email_deselect_all: "Tüm seçimi kaldır",
  email_reply_all: "Tümünü yanıtla",
  email_reply_placeholder: "Yanıtınızı yazın...",
  email_forward_placeholder: "Bir mesaj ekleyin...",
  email_edit_draft: "Taslağı düzenle",
  email_attach: "Ekle",
  email_attachment_from_original: "Orijinal mesajdan",
  email_remove: "Kaldır",
  email_drop_files: "Eklemek için dosyaları bırakın",
  email_loading_attachments: "Ekler yükleniyor...",
  email_archive: "Arşivle",
  mark_unread: "Okunmadı olarak işaretle",
  mark_read: "Okundu olarak işaretle",
  email_all_accounts: "Tüm hesaplar",
  email_error: "Hata",
  email_delete_email_failed: "E-posta silinemedi.",
  enter_url: "URL girin",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Şimdi abone ol',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 AY ÜCRETSİZ DENEME',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Bugün ödeme yok. Ücretli abonelik başlamadan önce kredi kartı bilgileri istenmez.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Tüm e-posta hesaplarını doğrudan Kjuup\'ta yönetin',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'Yapay zeka yanıtları yazar – siz yalnızca onaylarsınız',
  kjuup_io_feature_tasks: 'Görevler ve takvim her zaman otomatik güncel',
  kjuup_io_choose_plan: 'Plan seçin',
  kjuup_io_plan_monthly: 'Aylık',
  kjuup_io_plan_yearly: 'Yıllık',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Stripe ile güvende · istediğiniz zaman iptal edin',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Ödeme alındı. Aboneliğiniz etkinleştiriliyor…',
  kjuup_io_toast_activating_soon: 'Ödeme alındı. Aboneliğiniz kısa süre içinde etkinleşecek.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} saat kaldı',
  kjuup_io_trial_left_hour: '1 saat kaldı',
  kjuup_io_trial_left_minutes: '{count} dakika kaldı',
  kjuup_io_trial_left_minute: '1 dakika kaldı',
  kjuup_io_trial_left_seconds: '{count} saniye kaldı',
  kjuup_io_trial_left_second: '1 saniye kaldı',
  kjuup_io_trial_ending_now: 'Deneme süreniz bitiyor…',
  kjuup_io_request_timeout: 'Bağlantı zaman aşımına uğradı. Lütfen tekrar deneyin.',
  kjuup_io_info_days_free: '{days} gün tamamen ücretsiz – aboneliğiniz yalnızca deneme sonrası başlar.',
  kjuup_io_discount_total: 'İndiriminiz: %{percent}',
  kjuup_io_discount_company: '{company}: %{percent}',
  kjuup_io_discount_personal: 'Kişisel: %{percent}',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Kapat',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Ücretsiz deneme süreniz sona erdi',
  kjuup_io_trial_ended_body: 'E-posta ve diğer premium özellikleri kullanmaya devam etmek için Kjuup.io\'ya abone olun.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Ücretsiz deneme süreniz başladı',
  kjuup_io_toast_trial_fail: 'Ücretsiz deneme başlatılamadı',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / ay',
  kjuup_io_save_amount_year: 'Yılda {price} tasarruf edin',
  kjuup_io_billed_annually_amount: '{price} yıllık faturalandırılır',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Neler alırsınız:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Kredi kartı gerekmez – ödeme bilgisi olmadan hemen başlayın.',
  kjuup_io_info_cancel_anytime: 'İstediğiniz zaman iptal – taahhüt yok, risk yok.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Fatura dönemi',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Ödeme yöntemi kaydedildi. Ücret, deneme süresi sona erdiğinde alınacak.',
  calendar_sync_info: 'Tüm Kjuup ToDo\'larını otomatik olarak takviminizle senkronize edin.',
  calendar_no_accounts: 'Henüz bir takvim bağlanmadı.',
  article_new_badge: 'YENİ',
  article_new_posts: '{0} yeni gönderi',
  documents: 'Belgeler',
  add_documents: 'Belge ekle',
  no_preview_available: 'Önizleme kullanılamıyor',
  no_preview_hint: 'Bu dosya türü önizlenemiyor, ancak yine de gönderilecek.',
  max_documents_reached: 'Aynı anda en fazla 10 belge ekleyebilirsiniz.',
  open_file: 'Dosyayı aç',
  twofa_title: 'İki adımlı doğrulama',
  twofa_method_totp: 'Kimlik doğrulama uygulaması',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-posta',
  twofa_enter_app: 'Kimlik doğrulama uygulamasındaki 6 haneli kodu gir.',
  twofa_enter_sms: 'SMS ile gönderdiğimiz 6 haneli kodu gir.',
  twofa_enter_email: 'E-postana gönderdiğimiz 6 haneli kodu gir.',
  twofa_resend: 'Kodu yeniden gönder',
  twofa_try_another: 'Başka bir yöntem dene',
  twofa_remember_device: 'Bu cihazda 30 gün sorma',
  twofa_sent: 'Bir kod gönderdik.',
  twofa_invalid_code: 'Bu kod yanlış. Lütfen tekrar dene.',
  twofa_something_wrong: 'Bir şeyler ters gitti. Lütfen tekrar dene.',
  twofa_method_unavailable: 'Bu yöntem kullanılamıyor.',
  twofa_on_desc: 'İki adımlı doğrulama açık. Her girişte bir koda ihtiyacın olacak.',
  twofa_off_desc: 'Şifreden sonra ikinci bir adım ekle. Kimlik doğrulama uygulamaları en güvenli seçenektir.',
  twofa_methods: 'Yöntemler',
  twofa_on: 'Açık',
  twofa_add: 'Ekle',
  twofa_default_method: 'Varsayılan yöntem',
  twofa_default: 'Varsayılan',
  twofa_turn_off: 'Kapat',
  twofa_disable_hint: 'İki adımlı doğrulamayı kapatmak için şifreni ve güncel bir kodu gir.',
  twofa_disable_need: 'Şifreni ve bir doğrulama kodunu gir.',
  twofa_code_placeholder: '6 haneli kod veya yedek kod',
  twofa_send_code: 'Kod gönder',
  twofa_primary_updated: 'Varsayılan yöntem güncellendi.',
  twofa_disabled: 'İki adımlı doğrulama kapatıldı.',
  twofa_enabled: 'İki adımlı doğrulama artık açık.',
  twofa_totp_help: 'Bu QR kodunu Google Authenticator, Authy veya 1Password ile tara. Anahtarı elle de girebilirsin.',
  twofa_secret_copied: 'Anahtar kopyalandı',
  twofa_sms_help: 'Numaranı uluslararası formatta gir. 6 haneli bir kod SMS ile göndereceğiz.',
  twofa_email_help: 'Hesabındaki e-postaya 6 haneli bir kod göndereceğiz.',
  twofa_backup_title: 'Yedek kodlar',
  twofa_backup_help: 'Bu tek kullanımlık kodları güvenli bir yerde sakla. Telefonunu kaybedersen her kod bir kez kullanılır.',
  twofa_copy_codes: 'Kodları kopyala',
  twofa_codes_copied: 'Yedek kodlar kopyalandı',
  twofa_regenerate: 'Yeni yedek kodlar al',
  twofa_regenerate_hint: 'Bu, kullanılmayan yedek kodların yerine geçer. Parolanı ve güncel bir kodu gir.',
  twofa_backup_remaining: '{n} kullanılmayan yedek kod kaldı',
  twofa_new_codes: 'Yeni yedek kodlar',
  twofa_sms_unavailable: 'SMS kodları henüz kullanılamıyor.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Sana atanan Kjuup görevleri, Todoist içindeki bir Kjuup projesine kopyalanır. Todoist içindeki değişiklikler geri kopyalanmaz.",
  todoist_connect: "Todoist bağla",
  todoist_connected: "Todoist bağlandı",
  todoist_connect_failed: "Todoist bağlantısı başarısız",
  todoist_disconnect: "Bağlantıyı kes",
  todoist_disconnected: "Todoist bağlantısı kesildi",
  todoist_disconnect_confirm: "Todoist bağlantısı kesilsin mi? Todoist içinde olan görevler kalır. Eşitleme durur.",
  todoist_sync_now: "Şimdi eşitle",
  todoist_syncing: "Eşitleniyor…",
  todoist_sync_done: "Eşitleme bitti",
  todoist_sync_failed: "Eşitleme başarısız",
  todoist_auth_error: "Eşitlemeye devam etmek için Todoist hesabını yeniden bağla.",
  todoist_last_sync: "Son eşitleme",
  todoist_not_connected: "Todoist bağlı değil",
  todoist_auth_url_failed: "Todoist yetkilendirme sayfası açılamadı.",
  recommend_text: "Bağlantıda kalmak ve iletişimini düzenli tutmak için Kjuup'a katıl. Kanallarını bir araya getir, mesajları doğru projelerde tut ve her sabaha bir özet ve görevlerinle başla – hepsi zaten kullandığın uygulamalarla senkronize. Ücretsiz başla:",
  pro_auth_signin_title: 'Tekrar hoş geldiniz',
  pro_auth_signin_sub: 'İş e-postanızla giriş yapın.',
  pro_auth_email_or_username: 'E-posta veya kullanıcı adı',
  pro_auth_email_placeholder: 'ad@sirket.de',
  pro_auth_forgot_password: 'Şifrenizi mi unuttunuz?',
  pro_auth_create_account: 'Hesap oluştur',
  pro_auth_show_password: 'Şifreyi göster',
  pro_auth_hide_password: 'Şifreyi gizle',
  pro_auth_register_sub: 'E-postanızı onaylamanız için size bir bağlantı göndereceğiz.',
  pro_auth_register_plus_sub: 'Bir kullanıcı adı ve şifre seçin. Ardından güvenlik PIN\'inizi belirleyin.',
  pro_auth_check_credentials: 'E-postanızı ve şifrenizi kontrol edin',
  pro_news_export_pdf: 'PDF olarak dışa aktar',
  pro_news_pdf_failed: 'PDF oluşturulamadı.',
  pro_news_pdf_attachments: 'Ekler',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'E-postanızı girin, şifrenizi sıfırlamanız için size bir bağlantı gönderelim.',
  pro_auth_send_link: 'Sıfırlama bağlantısı gönder',
  pro_auth_plus_reset: 'PIN ile sıfırla',
  pro_auth_show_pin: 'PIN\'i göster',
  pro_auth_hide_pin: 'PIN\'i gizle',
  v2_auth_plus_only: 'Yalnızca Kjuup+',
  room_action_media: "Dosyalar",
  room_tab_overview: "Genel bakış",
  room_tab_history: "Geçmiş",
  chat_info_media: "Dosyalar",
  messages: "mesajlar",
  pro_todo_project_required: "Lütfen bir proje seçin",
  pro_todo_choose_project: "Bu görev hangi proje için?",
  cockpit_report_delete_confirm: "Bu günlük rapor silinsin mi?",
  cockpit_report_deleted: "Günlük rapor silindi",
  cockpit_tab_company: "Şirket",
  cockpit_bookmarked_priorities: "İşaretli görevler",
  cockpit_load_error: "Cockpit yüklenemedi.",
  cockpit_retry: "Tekrar dene",
  cockpit_yesterday: "Dün",
  cockpit_greeting_morning: "Günaydın",
  cockpit_greeting_day: "İyi günler",
  cockpit_greeting_evening: "İyi akşamlar",
  cockpit_assistant_q_open: "Bugün neler açık?",
  cockpit_assistant_q_summarize: "{{room}} sohbetini özetle",
  cockpit_assistant_q_overdue: "Hangi görevlerin süresi geçti?",
  cockpit_assistant_new: "{{n}} yeni",
  cockpit_assistant_important: "{{n}} önemli",
  cockpit_assistant_title: "Kjuup Asistanı",
  cockpit_assistant_hint: "Dokunun ve sorun",
  room_overview_priority_no_detail: "Rapor bu öncelik hakkında başka ayrıntı vermiyor.",
  room_overview_priority_from: "Kaynak: {{name}}",
  room_overview_priority_open_task: "Görevi aç",
  cockpit_priority_position: "{{total}} öncelikten {{index}}.",
  room_overview_today_title: "Bugün önemli",
  room_overview_all_tasks: "Tümü",
  room_overview_tasks_empty: "Açık son tarih veya görev yok",
  room_overview_appointments_empty: "Yaklaşan randevu yok",
  room_overview_no_priorities: "Son raporda açık öncelik yok.",
  cockpit_report_top5: "İlk 5 öncelik",
  cockpit_report_todo_created: "Görev oluşturuldu",
  cockpit_report_source_missing: "Kaynak mesaj bulunamadı.",
  delete_bookmarked_priority_confirm: "Bu işaretli görevi silmek istediğinizden emin misiniz?",
  cockpit_report_create_todo: "Görev oluştur",
  cockpit_priorities_deleting: "Siliniyor …",
  cockpit_priorities_select: "Birden çok sil",
  cockpit_report_none: "Kayıt yok.",
  cockpit_priorities_delete_confirm: "{count} işaretli görevi silmek istediğinizden emin misiniz?",
  cockpit_priorities_delete_failed: "{count} görev silinemedi",
  cockpit_priorities_deleted: "{count} görev silindi",
  cockpit_priorities_selected: "{count} seçildi",
  cockpit_channel_connected: "Bağlı",
  cockpit_channel_not_connected: "Bağlı değil",
  cockpit_channel_connect: "Bağlan",
  cockpit_channel_chat: "Kjuup sohbeti",
  cockpit_channel_active: "Etkin",
  cockpit_channel_hidden: "Gizli",
  cockpit_channel_enable: "Etkinleştir",
  cockpit_channel_email: "E-posta",
  cockpit_channel_check: "Bağlantıyı kontrol et",
  cockpit_channel_fix: "Kontrol et",
  cockpit_channel_forward: "Yönlendirme adresi",
  cockpit_channel_not_set_up: "Kurulmadı",
  cockpit_channel_set_up: "Kur",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Bağlantı kesildi",
  cockpit_channel_importing: "İçe aktarılıyor",
  cockpit_channel_removing: "Bağlantı kesiliyor",
  cockpit_channel_reconnect: "Yeniden bağlan",
  cockpit_channels_title: "Kanallar",
  cockpit_company_role_super_admin: "Şirket yöneticisi",
  cockpit_company_role_dept_admin: "Departman yöneticisi",
  cockpit_company_role_member: "Çalışan",
  cockpit_company_none: "Kjuup+ şirketi bulunamadı",
  cockpit_company_eyebrow: "Şirket",
  cockpit_company_inactive: "etkin değil",
  cockpit_company_settings: "Şirket ayarları",
  cockpit_company_employees: "Çalışanlar",
  cockpit_company_internal_rooms: "Dahili projeler",
  cockpit_report_all_projects: "Tüm projeler",
  cockpit_report_progress_emails: "E-postalar analiz ediliyor",
  cockpit_report_progress_chats: "Sohbet mesajları analiz ediliyor",
  cockpit_report_progress_documents: "Ekler ve belgeler analiz ediliyor",
  cockpit_report_progress_tasks: "Görevler analiz ediliyor",
  cockpit_report_progress_summarizing: "İçerik analiz ediliyor",
  cockpit_report_progress_reading: "Daha önce analiz edilen içerik yeniden kullanılıyor",
  cockpit_report_progress_collecting: "Projelerinizdeki e-postalar, sohbetler ve görevler toplanıyor",
  cockpit_report_progress_priorities: "Öncelikler, son tarihler ve kararlar derleniyor",
  cockpit_report_progress_queued: "Rapor hazırlanıyor",
  cockpit_report_creating_title: "Günlük raporunuz hazırlanıyor",
  cockpit_report_progress_count_one: "1 öğe analiz edildi",
  cockpit_report_progress_count_many: "{{count}} öğe analiz edildi",
  cockpit_report_progress_hint: "Bu genellikle bir iki dakika sürer – bu sırada Cockpit'i kullanmaya devam edebilirsiniz.",
  cockpit_report_time_hint: "Günlük rapor, en aktif beş proje için her gün saat {{hour}}:00'da oluşturulur.",
  room_overview_priorities_title: "Güncel durum ve öncelikler",
  room_overview_as_of: "{{time}} itibarıyla",
  cockpit_report_delete: "Günlük raporu sil",
  email_tag_daily_briefing: "Günlük rapor",
  cockpit_report_unread: "Yeni",
  cockpit_report_clear_project: "Tüm projeleri göster",
  cockpit_filter_project: "Proje",
  cockpit_filter_all_projects: "Tüm projeler",
  cockpit_report_recreate: "Günlük raporu yeniden oluştur",
  cockpit_report_hide_previous: "Önceki günlük raporları gizle",
  cockpit_report_show_previous: "Önceki günlük raporları göster",
  cockpit_report_room_empty: "Bu proje için henüz günlük rapor yok",
  cockpit_report_empty: "Henüz günlük rapor yok",
  cockpit_report_room_empty_hint: "Yalnızca bu proje için günlük rapor oluşturun.",
  cockpit_report_needs_mailbox: "Kjuup'un otomatik görevlerle günlük rapor oluşturabilmesi için bir e-posta hesabı bağlayın.",
  cockpit_report_create: "Günlük rapor oluştur",
  cockpit_email_connect: "E-posta bağla",
  cockpit_email_none_title: "Henüz bağlı e-posta hesabı yok",
  cockpit_email_none_reports: "Kjuup'un gelen e-postaları projelerinize atayabilmesi ve görevli günlük raporlar oluşturabilmesi için posta kutunuzu bağlayın.",
  cockpit_email_none_client: "E-postaları doğrudan Kjuup.io'da okumak, atamak ve yanıtlamak için Gmail, Outlook veya IMAP bağlayın.",
  cockpit_email_reports_title: "Mevcut e-posta istemcisi",
  cockpit_email_reports_text: "Kjuup.io'da gelen kutusu yok · saat {{hour}}:00'da günlük rapor alan {{rooms}} proje · gelen e-postalar projelerinize atanır.",
  cockpit_email_reports_rooms: "Projeleri yönet",
  cockpit_email_settings: "E-posta ayarları",
  cockpit_email_error_title: "Bağlantıyı kontrol et",
  cockpit_email_client_title: "Gelen kutusu bağlandı",
  cockpit_email_accounts_n: "{{n}} hesap bağlı",
  cockpit_email_last_sync: "son senkronizasyon {{when}}",
  cockpit_email_report_at: "Saat {{hour}}:00'da günlük rapor",
  cockpit_email_open_inbox: "Gelen kutusunu aç",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Bağlı e-posta adresleri",
  email_folder_sent: "Gönderilenler",
  email_no_subject: "(Konu yok)",
  cockpit_email_detail_loading: "E-posta yükleniyor …",
  cockpit_email_detail_failed: "E-posta yüklenemedi.",
  cockpit_email_detail_empty: "Bu e-postada metin yok.",
  cockpit_personal_settings: "Kişisel ayarlar",
  cockpit_companies: "Şirketler",
  cockpit_title: "Cockpit",
  cockpit_back: "Genel bakışa dön",
  cockpit_day_overview: "Gününüze genel bakış",
  email_saved_to_project: "E-posta projeye kaydedildi",
  email_classify_need_project: "Lütfen bir proje adı girin",
  cockpit_email_deleted: "E-posta silindi",
  cockpit_email_sent_empty: "Henüz gönderilmiş e-posta yok.",
  cockpit_email_incoming_empty: "Henüz gelen e-posta yok.",
  cockpit_email_incoming_title: "E-postalar",
  cockpit_email_incoming_sub: "Gelen ve gönderilen e-postaları projelerinize atayın. Atamayı buradan düzenleyebilirsiniz.",
  cockpit_email_incoming_unassigned_n: "{{n}} atanmamış",
  cockpit_email_folder_inbox: "Gelen kutusu",
  cockpit_email_folder_sent: "Gönderilenler",
  cockpit_email_open: "E-postayı aç",
  cockpit_email_incoming_suggested: "Öneri: {{room}}",
  cockpit_email_incoming_apply: "Uygula",
  cockpit_email_incoming_adjust: "Atamayı düzenle",
  cockpit_email_incoming_saving: "Kaydediliyor …",
  cockpit_email_incoming_unassigned: "Atanmamış",
  cockpit_email_incoming_show_less: "Daha az göster",
  cockpit_email_incoming_show_all: "{{n}} öğenin tümünü göster",
  cockpit_io_settings: "Kjuup.io Ayarları",
  cockpit_io_settings_sub: "Paket ve kullanıcı sayısı, çalışan ataması, faturalama ve faturalar.",
  products_coming_soon: "Çok yakında",
  cockpit_upsell_io_title: "Birlikte düşünen ofisiniz",
  cockpit_upsell_io_text: "E-posta hesaplarınızı Kjuup'a bağlayın. E-postalar, ekler ve mesajlar otomatik olarak ilgili projeye kaydedilir ve isteğe bağlı olarak sunucunuzda saklanabilir. Her gün tüm projelerin özetini, tüm içeriklerin önemli noktalarıyla birlikte alırsınız; görevleriniz takviminiz veya görev uygulamanızla senkronize edilir.",
  cockpit_upsell_io_soon_title: "Henüz satın alınamıyor",
  cockpit_upsell_io_soon_text: "Kjuup.io yakında yayında. Şimdi bilgi talep edin – Kjuup.io satın alınabilir olduğunda size haber vereceğiz.",
  cockpit_upsell_io_planned_price: "Planlanan fiyat",
  cockpit_upsell_io_cta_request: "Bilgi talep et",
  kjuup_plus_abo_per_year: "/ yıl",
  kjuup_plus_abo_per_month: "/ ay",
  kjuup_plus_abo_status_active: "Etkin",
  kjuup_plus_abo_status_requested: "İptal talep edildi",
  kjuup_plus_abo_status_past_due: "Ödeme gecikti",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Abonelik",
  kjuup_plus_abo_title: "Kjuup+ paketi",
  kjuup_plus_abo_seats_free_one: "1 kullanıcı hakkı kaldı",
  kjuup_plus_abo_billing: "Faturalama",
  kjuup_plus_abo_yearly: "Yıllık",
  kjuup_plus_abo_monthly: "Aylık",
  kjuup_plus_abo_amount: "Tutar",
  kjuup_plus_abo_ends: "Bitiş tarihi",
  kjuup_plus_abo_renews: "Sonraki yenileme",
  kjuup_plus_abo_next_invoice: "Sonraki fatura",
  kjuup_plus_abo_intro: "Tanıtım fiyatı",
  kjuup_plus_abo_pending_tier: "Sonraki yenilemeden itibaren",
  kjuup_plus_abo_manual: "Kjuup+, şirketiniz için bireysel bir anlaşma kapsamında etkin.",
  kjuup_plus_abo_invoices: "Faturalar",
  kjuup_plus_abo_invoice_paid: "Ödendi",
  kjuup_plus_abo_invoice_view: "Görüntüle",
  kjuup_plus_abo_invoices_less: "Daha az göster",
  kjuup_plus_abo_member_hint: "Faturalama ve iptal işlemlerini şirket yöneticileriniz yönetir.",
  kjuup_plus_abo_withdraw: "Talebi geri çek",
  kjuup_plus_abo_cancel_note: "Neden (isteğe bağlı)",
  kjuup_plus_abo_cancel_send: "İptal talep et",
  kjuup_plus_abo_cancel: "Aboneliği iptal et",
  cockpit_upsell_plus_f1: "Tüm çalışanlarınızın iletişim etkinliğini yönetin",
  cockpit_upsell_plus_f2: "Şirket içindeki belirli kullanıcı gruplarını bilgilendirin",
  cockpit_upsell_plus_f3: "Dahili grup sohbetlerini kaydedin",
  cockpit_upsell_plus_when_yearly: "yıllık ödemede",
  cockpit_upsell_plus_size_small: "1–50 çalışan",
  cockpit_upsell_plus_size_large: "51–200 çalışan",
  cockpit_upsell_plus_title: "Şirketler için Kjuup+",
  cockpit_upsell_plus_text: "Çalışanları, yazma izinlerini ve şirket iletişimini tek yerden yönetin. Dahili kanallar ekibinizde kalır, harici kanallar sizi proje ortaklarıyla buluşturur ve belirli gruplara doğrudan ulaşabilirsiniz. Kjuup+'a ek olarak çalışan grupları için Kjuup.io erişimi de satın alabilirsiniz. Kjuup+ ve Kjuup.io birlikte kullanılabilir.",
  cockpit_upsell_plus_size: "Şirket büyüklüğü",
  cockpit_upsell_plus_billing: "Faturalama",
  cockpit_upsell_plus_per_company: "/ şirket · ay, KDV hariç",
  cockpit_upsell_plus_onboarding: "Kurulum/eğitim maliyetleri şirket büyüklüğüne bağlıdır",
  cockpit_upsell_plus_larger: "Daha büyük şirketler için fiyatlar talep üzerine",
  cockpit_upsell_plus_cta: "Bağlayıcı olmayan talep",
  cockpit_kpi_deadlines_tasks: "Son tarihler ve görevler",
  cockpit_kpi_appointments: "Randevular",
  cockpit_room_admin: "Proje ve sohbet yönetimi",
  cockpit_room_admin_sub: "Şirketin tüm projeleri; üyeler, medya ve sohbetlerle birlikte.",
  pro_todo_not_found: "Bu görev artık mevcut değil.",
  cockpit_chip_overdue: "Süresi geçmiş",
  cockpit_chip_today: "Bugün",
  cockpit_calendar_week: "{{week}}. hafta",
  cockpit_prev_week: "Önceki hafta",
  cockpit_next_week: "Sonraki hafta",
  cockpit_chip_requested: "Talep edildi",
  cockpit_todo_due: "Son tarih {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "{{name}} tarafından",
  cockpit_todo_since: "{{when}} tarihinden beri",
  cockpit_todo_no_date: "Tarih yok",
  cockpit_todo_mark_done: "Tamamlandı olarak işaretle",
  cockpit_my_tasks_title: "Görevlerim",
  cockpit_today_tasks_group: "Bugünün görevleri",
  cockpit_assign_none: "Kimse atanmadı",
  no_project_found: "Proje bulunamadı",
  cockpit_row_more_actions: "Diğer işlemler",
  needs_date: "Tarih ata",
  cockpit_assign_proposal: "{{name}} algılandı – atansın mı?",
  cockpit_assign_proposal_confirm: "Ata",
  cockpit_assign_proposal_dismiss: "Yoksay",
  cockpit_priority_date: "Tarih",
  todo_calendar_add: "Takvime ekle",
  todo_calendar_remove: "Takvimden kaldır",
  cockpit_todo_change_project: "Projeyi değiştir",
  cockpit_todo_set_date: "Tarih belirle",
  pro_todo_done_confirm: "Bu görevi gerçekten tamamlandı olarak işaretlemek istiyor musunuz?",
  cockpit_task_delete_failed: "Görev silinemedi.",
  cockpit_setup_title: "Kurulumu tamamlayın",
  cockpit_setup_text: "Sohbetleri kullanmak isteyip istemediğinize ve Kjuup.io'nun e-posta istemcisi olarak mı yoksa yalnızca projeler ve günlük raporlarla mı çalışacağına karar verin.",
  cockpit_setup_cta: "Şimdi kur",
  cockpit_group_tasks: "Son tarihler ve görevler",
  cockpit_group_appointments: "Randevular",
  cockpit_report_no_activity: "Bu projede son 24 saatte yeni mesaj veya e-posta olmadı.",
  cockpit_report_room_unavailable: "Bu proje kullanılamıyor.",
  cockpit_report_create_failed: "Günlük rapor oluşturulamadı.",
  cockpit_report_created: "Günlük rapor oluşturuldu",
  addon_enable_confirm: "Eklenti etkinleştirilsin mi?",
  addon_enable: "Etkinleştir",
  addon_enabled: "Eklenti etkinleştirildi",
  nav_email: "E-posta",
  nav_my_cockpit: "Cockpit'im",
  nav_news: "Haberler",
  nav_recommend: "Tavsiye et",
  pro_todo_status_done: "Tamamlandı",
  pro_todo_status_open: "Açık",
  v2_todo_remove: "Kaldır",
  pro_todo_search_people: "Kişi ara",
  pro_todo_clear: "Temizle",
  pro_todo_assigned: "(atandı)",
  pro_todo_no_people: "Kişi bulunamadı",
  pro_todo_search_rooms: "Proje ara",
  pro_todo_no_rooms_match: "“{{q}}” ile eşleşen proje yok",
  pro_todo_no_rooms: "Proje bulunamadı",
  pro_todo_activity: "Etkinlik",
  pro_todo_show_less: "Daha az göster",
  pro_todo_show_all: "Tümünü göster ({{n}})",
  pro_todo_due: "Son tarih",
  pro_todo_room: "Proje",
  pro_todo_select_room: "Proje seç",
  pro_todo_status: "Durum",
  pro_todo_more: "Daha fazla",
  pro_todo_edit_title: "Görevi düzenle",
  pro_todo_description: "Açıklama",
  pro_todo_created_by: "Oluşturan",
  pro_todo_chat: "Sohbet",
  navigate_to_source: "Kaynağa git",
  todo_calendar_connect_title: "Bağlı takvim yok",
  todo_calendar_connect_body_web: "Görevleri takviminize eklemek için Takvim Senkronizasyonu ayarlarından bir takvim bağlayın.",
  todo_calendar_connect: "Bağlan",
  todo_calendar_removed: "Takviminizden kaldırıldı",
  todo_calendar_added_later: "Eklendi. Takviminize ulaşılamadı; Kjuup daha sonra tekrar deneyecek.",
  todo_calendar_added: "Takviminize eklendi",
  todo_calendar_no_date: "Yalnızca tarihi olan bir görev takvime eklenebilir.",
  todo_calendar_failed: "Takviminiz güncellenemedi. Lütfen tekrar deneyin.",
  todo_calendar_date_title: "Henüz tarih yok",
  todo_calendar_date_save: "Tarih belirle ve ekle",
  todo_calendar_date_body_web: "Bu işaretli görevin henüz tarihi yok. Takviminize eklemek için bir tarih belirleyin.",
  kjuup_io_setup_saved: "Kurulum kaydedildi",
  kjuup_io_setup_step: "Adım",
  kjuup_io_setup_chats_title: "Sohbetleri kullanmak istiyor musunuz?",
  kjuup_io_setup_email_title: "E-postalarınızı nerede okumak istiyorsunuz?",
  kjuup_io_setup_chats_sub: "Meslektaşlarınız ve proje ortaklarınızla sohbetler isteğe bağlıdır. Bunları Cockpit'te istediğiniz zaman gösterebilir veya gizleyebilirsiniz.",
  kjuup_io_setup_email_sub: "Bu yalnızca Kjuup'ta bir e-posta istemcisi kullanıp kullanmayacağınızı veya Outlook ya da başka bir mevcut e-posta programınızı kullanmaya devam edeceğinizi belirler. Daha sonra değiştirebilirsiniz.",
  kjuup_io_setup_chats_yes: "Evet, sohbetleri göster",
  kjuup_io_setup_chats_yes_text: "“Mesajlar” sohbetleri ve e-postaları içerir. Projelerde tüm katılımcılar için grup sohbetleri bulunur.",
  kjuup_io_setup_chats_no: "Hayır, sohbetsiz çalış",
  kjuup_io_setup_chats_no_text: "Sohbetler gizlenir. “Mesajlar” “E-posta” olur; projeler, görevler ve günlük raporlar kalır.",
  kjuup_io_setup_email_client: "Kjuup'ta e-posta istemcisi",
  kjuup_io_setup_email_client_text: "E-postaları doğrudan Kjuup'ta okuyun ve yanıtlayın.",
  kjuup_io_setup_email_reports: "Mevcut e-posta istemcisi",
  kjuup_io_setup_email_reports_text: "Outlook veya başka bir mevcut programınızda okumaya ve yanıtlamaya devam edin.",
  kjuup_io_setup_skip: "Daha sonra",
  next: "İleri",
  kjuup_io_setup_finish: "Kurulumu bitir",
  today_label: "bugün",
  tomorrow_label: "yarın",
  cockpit_todo_overdue: "süresi geçmiş",
  cockpit_report_management_fazit: "Yönetici özeti",
  cockpit_todo_appointment: "Randevu",
  cockpit_todo_deadline: "Son tarih",
  cockpit_todo_deadline_define: "Son tarih belirle",
  pro_todo_status_acknowledged: "Onaylandı",
  pro_todo_responsible: "Sorumlu",
  pro_todo_notice_confirmed: "Sohbette onaylandı",
  pro_todo_notice_sent_at: "Mesaj gönderildi",
  pro_todo_notice_again: "Mesajı tekrar gönder",
  pro_todo_notice_send: "Kjuup mesajıyla bilgilendir",
  pro_todo_add_assignee: "Ekle",
  pro_todo_edit: "Düzenle",
  pro_todo_change_room: "Projeyi değiştir",
  pro_todo_due_on: "Son tarih",
  pro_todo_edit_due: "Son tarihi düzenle",
  pro_todo_no_date: "Tarih yok",
  pro_todo_edit_description: "Açıklamayı düzenle",
  pro_todo_no_description: "Henüz açıklama yok",
  pro_todo_title_label: "Başlık",
  pro_todo_title_placeholder: "Başlık girin...",
  pro_todo_task: "Görev",
  pro_todo_what: "Ne yapılması gerekiyor?",
  pro_todo_source_email: "E-posta",
  pro_todo_sources: "Kaynaklar",
  previous: "Önceki",
  kjuup_plus_abo_tier_large: "Kjuup+ Large ({max} çalışana kadar)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small ({max} çalışana kadar)",
  kjuup_plus_abo_status_ends: "{date} tarihinde sona eriyor",
  kjuup_plus_abo_seats_over: "{max} çalışandan fazla – Kjuup size özel bir teklifle ulaşacak.",
  kjuup_plus_abo_seats_next: "Daha fazla çalışan katılırsa paket otomatik olarak {next} olur (kalan süreye göre ücretlendirilir).",
  kjuup_plus_abo_seats_used: "{used} / {total} kullanıcı hakkı kullanılıyor",
  kjuup_plus_abo_seats_free: "{count} kullanıcı hakkı kaldı",
  kjuup_plus_abo_intro_until: "{date} tarihine kadar",
  kjuup_plus_abo_invoice_open: "Açık · son ödeme {date}",
  kjuup_plus_abo_invoices_all: "Tümünü göster ({count})",
  kjuup_plus_abo_requested_hint: "İptal {date} tarihinde talep edildi. Kjuup iptali dönem sonunda ({end}) onaylayacak.",
  kjuup_plus_abo_cancel_hint: "Kjuup talebinizi inceler ve iptali dönem sonunda ({end}) onaylar. Kjuup+ o zamana kadar etkin kalır.",
  kjuup_plus_abo_withdrawn: "İptal talebi geri çekildi",
  kjuup_plus_abo_requested: "İptal talep edildi",
  cockpit_upsell_plus_intro_hint: "ilk {months} ay, ardından {price}",
  cockpit_upsell_plus_badge: "{months} AY İÇİN TANITIM FİYATI",
  calendar_syncing: "Takvimden güncelleniyor…",
  calendar_sync_up_to_date: "Takvim güncel",
  calendar_sync_failed: "Senkronizasyon başarısız",
  delete_multiple_tasks_confirm: "{count} ToDo'yu silmek istediğinizden emin misiniz?",
  todos_deleted_count: "{count} ToDo silindi",
  todos_deleted_partial: "{ok} ToDo silindi, {fail} başarısız",
  todo_unknown: "Bilinmiyor",
  todo_created_from_message: "Bu mesajdan görev oluşturuldu",
  kjuup_io_todo_calendar_trial_ended_note: "Takvim senkronizasyonu · Abone ol",
  kjuup_io_todo_calendar_nudge: "Bu ToDo takviminizle senkronize edilsin mi?",
  kjuup_io_todo_calendar_nudge_cta: "Kjuup.io'yu etkinleştir",
  todo_confirmed: "ToDo onaylandı",
  pro_todo_bulk_delete_title: "{{n}} görev silinsin mi?",
  pro_todo_previous_none_own: "Gecikmiş görevler size başkaları tarafından atandı ve yalnızca onlar tarafından silinebilir.",
  pro_todo_previous_none: "Gecikmiş görev yok",
  pro_todo_previous_title: "{{n}} gecikmiş görev silinsin mi?",
  pro_todo_previous_text: "Önceki günlere ait tüm açık görevleriniz silinecek.",
  pro_todo_previous_skipped: "Başkaları tarafından atanan {{n}} görev kalacak.",
  unassign_task_confirm: "Bu görevden atamanızı kaldırmak istiyor musunuz?",
  unassign_label: "Kaldır",
  pro_todo_delete_title: "Görevi sil",
  pro_todo_today: "Bugün",
  pro_todo_yesterday: "Dün",
  pro_todo_since_yesterday: "Dünden beri",
  pro_todo_mark_open: "Açık olarak işaretle",
  verify_completion: "Doğrula",
  new_label: "Yeni",
  bookmarked_no_mylist: "Yer imli görevler Listeme eklenemez",
  delete_only_own: "Yalnızca kendi oluşturduğunuz görevleri silebilirsiniz",
  todo_clear_all: "Tümünü temizle",
  pro_todo_of_completed: "{{done}} / {{total}} tamamlandı",
  pro_todo_pick_date: "Bir tarih seçin",
  pro_todo_show_day: "Günü göster",
  todo_adjust_list: "Listeyi düzenle",
  pro_todo_section_upcoming: "Yaklaşan",
  pro_todo_section_done: "Tamamlandı",
  pro_todo_room_empty_today: "Bu projede bugün için görev yok",
  pro_todo_room_empty_day: "Bu projede bu gün için görev yok",
  pro_todo_delete_previous: "Tümünü sil",
  todo_my_list_empty: "Günün boş",
  todo_my_list_empty_hint: "Görev eklemek için “Listeyi düzenle” düğmesine tıklayın",
  pro_todo_empty_title: "Burada bir şey yok",
  pro_todo_empty_hint: "Bu görünümle eşleşen görev yok.",
  pro_todo_selected: "{{n}} seçildi",
  delete_selected_count: "Sil ({count})",
  pro_todo_adjust_done: "Bitti",
  pro_todo_deleting: "Siliniyor...",
  pro_todo_reopen: "Görevi yeniden aç",
  pro_todo_step_done: "Tamamlandı",
  move_back_in_progress: "Devam eden durumuna geri dön",
  pro_todo_mark_not_started: "Başlanmadı olarak işaretle",
  back_into_in_progress: "Devam eden durumuna geri dön",
  pro_todo_mark_in_progress: "Devam ediyor olarak işaretle",
  unassign_todo: "ToDo atamasını kaldır",
  pro_todo_open_room: "Projeyi aç",
  pro_todo_new_task: "Yeni görev",
  select_user_back_to_in_progress: "Devam ediyor durumuna geri alınacak kullanıcıyı seçin",
  cockpit_email_accounts_n_many: "{{n}} hesap bağlı",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup kişileri",
  combined_tab_teams: "Teams kişileri",
  combined_bridge_failed: "Teams kopyası oluşturulamadı.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup ve Teams kişileri: Microsoft Teams'te de görünen yeni bir grup oluşturulur.",
  teams_new_chat_title: "Yeni Teams sohbeti",
  teams_new_chat_topic: "Grup adı (isteğe bağlı)",
  teams_new_chat_start: "Sohbeti başlat",
  teams_new_chat_creating: "Sohbet oluşturuluyor…",
  teams_new_chat_forbidden: "Microsoft Teams bu sohbete izin vermiyor (ör. kuruluşunuz dışındaki bir kişi veya BT biriminizin bir kuralı).",
  teams_new_chat_too_many: "Bir sohbet için çok fazla kişi.",
  teams_new_chat_type_hint: "Kuruluşunuzda aramak için bir ad yazın.",
  teams_new_chat_directory_forbidden: "Kuruluşunuz dizinde aramaya izin vermiyor. Yalnızca Teams sohbetlerinizdeki kişiler gösteriliyor.",
  teams_new_chat_account: "Hesap",
};
